<template>
  <div>
    <Table :data="resources" :columns="columns" size="small" highlight-row stripe max-height="700">
    </Table>
  </div>
</template>
<script>

export default {
  props: {
    row: Object
  },
  data() {
    return {
      loading: false,
      pdf_view: false,
      contract_id: null,
    }
  },
  computed: {
    resources() {
      return this.row.replacement_details
    },
    columns() {
      return [
        {
          title: this.$t('sparePartReplacement.productName'),
          key: 'product_name_en',
          width: 260
        },
        {
          title: this.$t('sparePartReplacement.uom'),
          key: 'uom_name_en',
          align: 'center',
          width: 200
        },
        {
          title: this.$t('sparePartReplacement.quantity'),
          key: 'quantity',
          align: 'center',
          width: 200
        },
        {
          title: this.$t('sparePartReplacement.cost'),
          key: 'cost',
          align: 'center',
          width: 200
        },
        {
          title: this.$t('sparePartReplacement.technician'),
          key: 'employee_name_en',
          width: 250
        },
        {
          title: this.$t('sparePartReplacement.remark'),
          key: 'remarks',
        }
      ]
    }
  },
  methods: {}
}
</script>